module.exports = __webpack_public_path__ + "static/970-d3f0fae722af4534e62fecd084a092d8.png";